import _ from "lodash";
import Api, {dateToServer} from "services/Api";
import {promiseQueue} from "services/helper";
import {extractIncome} from "services/personFunctions";
import claimDetails from "store/modules/fatal/estate/claimDetails";
import calculateLoss from "store/modules/fatal/estate/calculateLoss";
import people from "store/modules/fatal/estate/people";
import proceduralDates from "store/modules/fatal/estate/proceduralDates";
import headsOfLoss from "store/modules/fatal/estate/headsOfLoss";
import step from "store/modules/fatal/estate/step";
import cru from "store/modules/fatal/estate/cru";
import interimPayments from "store/modules/fatal/estate/interimPayments";
import psla from "store/modules/psla";
import moment from 'moment';
import store from 'store/index';
import deceased from 'store/modules/fatal/estate/deceased';
import {isStepValid} from 'services/routingMethods';
import documents from 'store/modules/lost/documents';

const mutationTypes = {
    LOADING_CLAIM: 'LOADING_CLAIM',
    UPDATING_TABLE: 'UPDATING_TABLE',
    CHANGE_CLAIM_ID: 'CHANGE_CLAIM_ID',
    FINISHED_LOADING_CLAIM: 'FINISHED_LOADING_CLAIM',
};

// Initial State
const state = {
    claimId: null,
};

// Getters
const getters = {};

// Actions
const actions = {
    /**
     * Dispatches save requests to the correct step.
     *
     * @param rootGetters
     * @param payload
     */
    save({rootGetters}, payload) {
        let individualStep = rootGetters['fatal/estate/step/allSteps'][payload.step_number];

        return store.dispatch('fatal/estate/' + individualStep.store + '/save', payload);
    },

    /**
     * Dispatches loading of a step requests to the correct step.
     *
     * @param dispatch
     * @param rootGetters
     * @param step
     */
    load({dispatch, rootGetters}, step) {
        let individualStep = rootGetters['fatal/estate/step/allSteps'][parseInt(step.step_number, 10)];

        dispatch('checkForStepStore', individualStep)
            .then(() => store.dispatch('fatal/estate/' + individualStep.store + '/load', step));
    },

    /**
     * Dispatches process requests to the correct step.
     *
     * @param commit
     * @param dispatch
     * @param step
     */
    process({dispatch}, step) {
        dispatch('checkForStepStore', step)
            .then(() => store.dispatch('fatal/estate/' + step.store + '/process', step))
            .then(() => {
                dispatch('headsOfLoss/calcAllInterest');
            });
    },

    /**
     * Dispatches validate requests to the correct step.
     */
    validate({dispatch}, step) {
        dispatch('checkForStepStore', step)
            .then(() => {
                store.dispatch('fatal/estate/' + step.store + '/validate', step)
            });
    },

    /**
     * Dispatches reset requests to the correct step.
     *
     * @param dispatch
     * @param step
     */
    reset({dispatch, rootState}, step) {
        dispatch('checkForStepStore', step)
            .then(() => {
                // Only attempt to reset steps on this store.
                if (rootState.fatal.estate[step.store]) {
                    store.dispatch('fatal/estate/' + step.store + '/reset', step);
                }
            });
    },

    /**
     * Checks that a Step has its store defined in the routes, otherwise throws an error.
     *
     * @param individualStep
     */
    checkForStepStore(none, individualStep) {
        if (!individualStep.store) {
            throw {'error': 'Step #' + individualStep.step + ' (' + individualStep.name + ') does not have a store defined in the routes meta'};
        }
    },
};

const mutations = {
    [mutationTypes.CHANGE_CLAIM_ID](state, payload) {
        state.claimId = payload;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
    modules: {
        calculateLoss,
        claimDetails,
        people,
        proceduralDates,
        headsOfLoss,
        cru,
        interimPayments,
        psla,
        step,
        deceased,
        documents,
    },
};



// WEBPACK FOOTER //
// ./src/store/modules/fatal/estate/index.js